import { Injectable } from '@angular/core';
import { MyApplicationForUi } from '@core/typings/application.typing';
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';
import { CommunicationFlyoutDetails, CommunicationForApplicant } from '../typings/applicant-communications.typing';

@RegisterYCState()
@Injectable({ providedIn: 'root' })
export class ApplicantCommunicationState extends BaseYcState {
  readonly applicationCommunicationsMap: Record<number, CommunicationForApplicant[]> = {};
  readonly communicationFlyoutDetails: Record<string, CommunicationFlyoutDetails> = {};
  readonly currentFlyoutApp: MyApplicationForUi;
}

